const NUTRI_SCORE_POINTS = {
  A: 4,
  B: 3,
  C: 2,
  D: 1,
  E: 0,
};

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function toNumber(value, fallback = null) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function computeProductRating(product = {}) {
  const nutriScore = String(product.nutri_score || product.nutriscore_grade || '').toUpperCase();
  const nutrition = product.nutrition || {};

  const calories = toNumber(nutrition.calories_100g, toNumber(product.energy_kcal_100g));
  const sugar = toNumber(nutrition.sugars_100g, toNumber(product.sugars_100g));
  const fiber = toNumber(nutrition.fiber_100g, toNumber(product.fiber_100g));
  const protein = toNumber(nutrition.proteins_100g, toNumber(product.proteins_100g));
  const sodium = toNumber(nutrition.sodium_100g, toNumber(product.sodium_100g));
  const salt = toNumber(nutrition.salt_100g, toNumber(product.salt_100g));
  const novaGroup = toNumber(product.nova_group, null);

  let score = 5;

  score += NUTRI_SCORE_POINTS[nutriScore] ?? 0;

  if (fiber != null) {
    if (fiber >= 6) score += 1.2;
    else if (fiber >= 3) score += 0.6;
  }

  if (protein != null) {
    if (protein >= 10) score += 0.9;
    else if (protein >= 5) score += 0.4;
  }

  if (sugar != null) {
    if (sugar >= 20) score -= 1.5;
    else if (sugar >= 10) score -= 0.8;
  }

  const sodiumOrSalt = sodium != null ? sodium : (salt != null ? salt / 2.5 : null);
  if (sodiumOrSalt != null) {
    if (sodiumOrSalt >= 0.8) score -= 1.4;
    else if (sodiumOrSalt >= 0.3) score -= 0.7;
  }

  if (calories != null) {
    if (calories > 450) score -= 1;
    else if (calories > 300) score -= 0.4;
  }

  if (novaGroup != null && novaGroup >= 4) {
    score -= 0.8;
  }

  const finalScore = Number(clamp(score, 0, 10).toFixed(1));

  const positives = [];
  const watch = [];

  if (['A', 'B'].includes(nutriScore)) positives.push(`Nutri-Score ${nutriScore}`);
  if (fiber != null && fiber >= 3) positives.push('Bonne teneur en fibres');
  if (protein != null && protein >= 5) positives.push('Apport proteique interessant');

  if (sugar != null && sugar >= 10) watch.push('Teneur en sucres elevee');
  if (sodiumOrSalt != null && sodiumOrSalt >= 0.3) watch.push('Teneur en sel/sodium a surveiller');
  if (novaGroup != null && novaGroup >= 4) watch.push('Produit ultra-transforme (NOVA 4)');

  let summary = 'A consommer occasionnellement';
  if (finalScore >= 7.5) summary = 'Bon choix';
  else if (finalScore < 4.5) summary = 'Plutot a limiter';

  return {
    score: finalScore,
    nutriScore: nutriScore || null,
    summary,
    pointsForts: positives,
    pointsSurveillance: watch,
    verdict: summary,
  };
}
